import { motion } from 'framer-motion';
import * as Motioner from '../utils/MotionerUtil';
import { twMerge } from 'tailwind-merge';

const IconButton = ({ children, className, ...properties }) => (
    <motion.button className={twMerge('flex items-center justify-center h-14 aspect-square cursor-pointer bg-blue-900 text-white rounded-lg', className)} {...Motioner.click} {...properties}>
        {children}
    </motion.button>
);

export default IconButton;
